


















import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import ExpTableManager from './components/ExpTableManager.vue';
import ExpTableHooks from './components/ExpTableHooks.vue';

@Component({
    components: {
        ExpTableManager,
        ExpTableHooks
    }
})
export default class ExpManager extends Vue {
    // Data
    tab = null;

    successMessage = false;
    error = {
        show: false,
        message: ''
    };

    public onError(err: any) {
        this.error.show = true;
        this.error.message = err.message;
    }
}
